<template>
  <el-dialog
    width="600px"
    :visible="show"
    :title="title"
    @close="$emit('update:visible', false)"
  >
      <div class="bind">
        <div class="bind-tree">
          <el-tree
            lazy
            ref="refTree"
            :props="props"
            :load="onLoadNode"
            node-key="organizationId"
            show-checkbox
            @check="onChange"
            :default-checked-keys="checkedKeys"
            :default-expanded-keys="defaultKeys"
          />
        </div>
        <div class="bind-list">
          <div class="bind-list-item" v-for="(item,index) in selectData" :key="index">
            <el-tag v-if="item.type === 2" size="small">车辆</el-tag>
            <el-tag v-else type="success" size="small">车组</el-tag>
            <p>{{ item.organizationName }}</p>
            <i @click="onDel(item)" class="el-icon-error"></i>
          </div>
        </div>
      </div>
      <div class="footer">
        <el-button size="small" @click="$emit('update:visible', false)">取 消</el-button>
        <el-button size="small" type="primary" @click="onConfirm">确 认</el-button>
      </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    pathId: {
      type: Number,
      default:null
    },
    visible:{
      type:Boolean,
      default:false
    }
  },

  data() {
    return {
      loading:false,
      treeData: [],
      selectData:[],
      defaultKeys:[],
      checkedKeys:[],
      props: {
        label: 'organizationName',
        children: 'organizationsList',
        isLeaf:'leaf'
      }
    };
  },
  computed:{
    title(){
      return '绑定数据';
    },
    show:{
      get(){
        return this.visible;
      },
      set(val){
        this.$emit('update:visible',val);
      }
    }
  },
  watch: {
    show:{
      handler(val){
        this.$nextTick(() => {
          val && this.getVehicleBindInfo();
          val && this.getData();
        })
      },
      deep:true
    }
  },
  methods: {
    // 确认
    async onConfirm(){
      try{
        let gids = [];
        let vids = [];
        this.selectData.map(item => {
          if(item.type === 2){
            vids.push(item.organizationId);
          }else{
            gids.push(item.organizationId);
          }
        });
        const { msg, code } = await this.$API.bindVehicleToPath({
          pathId:this.pathId,
          gids:gids.join(','),
          vids:vids.join(','),
        });
        if(code !== 0) throw { msg };
        this.$emit('update:visible', false);
        this.$emit('onSuccess');
        this.$msg({
          type:'success',
          message:'绑定成功'
        });
      }catch(err){
        this.$msg({
          type:'error',
          message:err.msg
        });
      }
    },
    // 获取已绑定数据
    async getVehicleBindInfo(){
      try{
        const { msg, code, data } = await this.$API.getVehicleBindInfo({ pathId:this.pathId });
        if(code !== 0) throw { msg };
        if(data){
          this.defaultKeys = [];
          this.checkedKeys = [];
          this.selectData = [];
          data.map(item => {
            this.selectData.push({
              organizationName:item.name,
              organizationId:item.gvid,
              type:item.type === 'VEHICLE' ? 2 : 1,
            });
            this.checkedKeys.push(item.gvid);
            if(item.type === 'VEHICLE' && !this.defaultKeys.includes(item.groupId)){
              this.defaultKeys.push(item.groupId);
            }
          });
          console.log(this.defaultKeys,this.checkedKeys,'this.defaultKeys')
        }
      }catch(err){
        console.log(err);
      }
    },
    // 获取车组
    async getData(){
      try{
        const { msg, code, data } = await this.$API.getOTree();
        if(code !== 0) throw { msg };
        this.treeData = data ?? [];
        // await this.$sleep(300);
        this.treeData.map(item => {
          this.$refs.refTree.setChecked(item.organizationId,false,true);
        });
      }catch(err){
        console.log(err);
      }
    },
    async onLoadNode(node, resolve) {
      console.log(node);
      if (node.level === 0) {
        await this.$sleep();
        return resolve(this.treeData);
      }
      if (node.level > 1) return resolve([]);
      try{
        const { msg, code, data } = await this.$API.getVehicleState({
          organizationIds: node.data.organizationId,
          pagger: 1,
          total: 100,
          type: 3,
         });
        if(code !== 0) throw { msg };
        const params = data?.MonitoringCenterVos.map(item => ({
          organizationName:item.bmsNo,
          organizationId:item.vehicleId,
          type:2,
          leaf:true
        }))
        return resolve(params);
      }catch(err){
        console.log(err);
      }
    },
    // 勾选回调
    onChange(){
      this.selectData = this.$refs.refTree.getCheckedNodes();
    },
    // 删除
    onDel(item){
      this.$refs.refTree.setChecked(item.organizationId,false);
      this.onChange();
    }

  }
};
</script>
<style lang="scss" scoped>
div{
  box-sizing: border-box;
}
::v-deep .el-dialog__body{
  padding: 10px;
  border-top: 1px solid #EEE;
}
.bind{
  display: flex;
  justify-content: space-between;
  height: 400px;
  &-tree{
    width: 50%;
    height: 100%;
    padding: 14px;
    border: 1px solid #EEE;
    overflow-y: auto;
    @include scrollBar;
  }
  &-list{
    width: 50%;
    height: 100%;
    border: 1px solid #EEE;
    border-left: none;
    overflow-y: auto;
    @include scrollBar;
    &-item{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #eee;
      flex-direction: row;
      &:hover{
        background: rgba($color: #eee, $alpha: 0.4);
      }
      .el-tag{
        margin-right: 10px;
      }
      >p{
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      >i{
        cursor: pointer;
        font-size: 18px;
        &:hover{
          color: #00D3B8;
        }
      }
    }
  }
}
.footer{
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
</style>
